<script type="text/ecmascript-6">

    export default {
        props: {
            id: {},
            headline: {},
            subheadline: {},
            elClass: {},
            deactivated: { 'default': function () { return false } },
            large: false,
        },

        data() {
            return {
                isOpen: false
            }
        },

        computed: {
            'div_id': function () {
                return 'lightbox-' + this.id;
            }
        },

        methods: {
            open: function () {
                // Listen to this even like this: <Lightbox @lightbox-opened="doThis"
                // Maybe to load some shared data across all lightboxes of same type
                this.$emit('lightboxopening');
                this.isOpen = true;

                $('#'+this.id).on('hidden.bs.modal', () => {
                    this.$emit('lightboxclosing');
                    this.isOpen = false;
                }).modal('show');
            }
        }
    }
</script>
<template>
    <div :id="div_id" class="lightbox" :class="elClass">

        <template v-if="deactivated">
            <slot name="open-template">Open lightbox</slot>
        </template>
        <template v-else>
            <a @click="open"><slot name="open-template">Open lightbox</slot></a>
        </template>

        <div class="modal inmodal" :id="id" tabindex="-1" role="dialog" aria-hidden="true">
            <div :class="['modal-dialog', large ? 'modal-lg' : '']">
                <div class="modal-content animated fadeIn">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal"><span
                                aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>
                        <h4 class="modal-title" v-html="headline"></h4>

                        <slot name="subheadline">
                            <small v-if="subheadline" class="font-bold" v-html="subheadline"></small>
                        </slot>
                    </div>
                    <div class="modal-body">

                        <slot name="body" :is-open="isOpen">
                            Das ist eine Lightbox
                        </slot>

                    </div>
                    <div class="modal-footer">

                        <slot name="footer">
                            <button id="" type="button" class="btn btn-white" data-dismiss="modal" v-text="__('scoop-os.common.close')"></button>
                            <!--<button type="button" class="btn btn-primary" v-text="__('scoop-os.common.save')"></button>-->
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
</style>
